/**
 * One-shot: the Settings toggle-on asks the next *live* 3D mouse to write Drone. localStorage restore
 * never sets this. The flag is peeked across effect remounts (Strict Mode, view identity) and spent
 * only in `on3dmouseCreated`, so a handshake that never creates a mouse does not burn it, and a
 * reconnect after a successful write does not rewrite. `prompt` → `granted` does not remount the
 * connect effect, so that path cannot spend the flag twice.
 */
let pending = false;

/** Call from the Settings toggle when the user turns SpaceMouse on. */
export function requestDroneOnNextConnect(): void {
    pending = true;
}

/** Call when the user turns SpaceMouse off before that session comes up. */
export function clearDroneOnNextConnect(): void {
    pending = false;
}

/** True once, when a 3D mouse actually exists. Call from `handleCreated`, not from effect setup. */
export function consumeDroneOnNextConnect(): boolean {
    if (!pending) {
        return false;
    }
    pending = false;
    return true;
}
